import React, { useCallback } from "react";
import styled from "styled-components";
import cx from "classnames";
import { UPLOAD_SOURCES } from "@cld/upload-widget";
import t from "common/i18n";
import TopMenuItem from "../../TopMenuItem";

const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	align-items: flex-start;
`;

const MenuToggle = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-start;
	border-bottom-style: solid;
	border-bottom-width: ${({ isMenuOpen }) => isMenuOpen ? "1" : "0"}px;
`;

const List = styled.ul`
	display: flex;
	flex-direction: column;
	overflow-y: scroll;
	z-index: 10000;
	transition: all 0.3s;
	width: 100%;
	height: 100%;
	align-items: flex-start;

	transform: ${({ isMenuOpen }) => isMenuOpen ? "none" : "translateX(-100%)"};
	opacity: ${({ isMenuOpen }) => isMenuOpen ? "1" : "0"};
`;

const ListItem = styled.li`
	display: flex;
	padding-left: 10px;
	margin-top: 6px;
`;

const ResponsiveMenuItems = (
	{
		items,
		titles,
		isMenuOpen,
		activeItemId,
		navigateToPath,
		showFileSelection,
		toggleMenu,
	}) => {
	const activeItem = items.find((i) => i.id === activeItemId);

	const onItemClick = useCallback((e, id, path) => {
		if (activeItemId !== id) {
			navigateToPath(path);
		}

		if (id === UPLOAD_SOURCES.LOCAL) {
			showFileSelection();
		} else {
			toggleMenu(!isMenuOpen);
		}
	}, [showFileSelection, activeItemId, navigateToPath, toggleMenu, isMenuOpen]);

	const getIsItemActive = useCallback((id) => {
		return id !== UPLOAD_SOURCES.LOCAL && id === activeItemId;
	}, [activeItemId]);

	return (
		<Container>
			<MenuToggle isMenuOpen={isMenuOpen}
			            data-test="responsive-menu-toggle"
			            className={cx(
				            "bc-window top-menu-height",
				            { "bc-window-border": isMenuOpen },
			            )}>
				<ListItem>
					{activeItem ? <TopMenuItem
						{...activeItem}
						title={t(titles[activeItem.id])}
						isVertical
						onClick={onItemClick}
						getIsShownAsActive={getIsItemActive}
					/> : null}
				</ListItem>
			</MenuToggle>
			<List className="bc-window dropdown-items bc-window-border bg-window"
			      data-test="responsive-menu-list"
			      isMenuOpen={isMenuOpen}>
				{items.map((item) => <ListItem key={item.id}>
					<TopMenuItem
						{...item}
						title={t(titles[item.id])}
						isVertical
						onClick={onItemClick}
						getIsShownAsActive={getIsItemActive}
					/>
				</ListItem>)}
			</List>
		</Container>
	);
};

export default ResponsiveMenuItems;

